// Web replacement for @notifee/react-native: badge via the Badging API,
// foreground notifications via the Notification API.
export enum AndroidImportance {
  DEFAULT = 3,
  HIGH = 4,
  LOW = 2,
  MIN = 1,
  NONE = 0,
}

type DisplayNotification = { title?: string; body?: string; data?: Record<string, unknown> };

const notifee = {
  async createChannel(channel: { id: string }) {
    return channel.id;
  },
  async setBadgeCount(count: number) {
    const nav = navigator as Navigator & {
      setAppBadge?: (n: number) => Promise<void>;
      clearAppBadge?: () => Promise<void>;
    };
    try {
      if (count > 0) await nav.setAppBadge?.(count);
      else await nav.clearAppBadge?.();
    } catch {
      // Badging is optional; unsupported browsers just ignore it.
    }
  },
  async displayNotification({ title, body }: DisplayNotification) {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    new Notification(title ?? '', { body });
  },
};

export default notifee;
